import type { ReactNode } from 'react';
import type { IconComponent } from './icons';

/** Estado vazio de uma lista ou tela: ícone, título, texto e ação. */

export interface EmptyStateProps {
  /** Título do estado vazio. */
  title: string;
  /** Texto explicativo (opcional). */
  description?: string;
  /** Ícone opcional (um de `ICONS`). */
  icon?: IconComponent;
  /** Ação principal (botão) abaixo do texto. */
  action?: ReactNode;
  /** `data-testid` opcional — alguns e2e dependem do testid do estado vazio. */
  'data-testid'?: string;
}

export function EmptyState({ title, description, icon: Icon, action, ...rest }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center gap-3 py-8 text-center text-kumo-subtle" {...rest}>
      {Icon ? <Icon size={32} /> : null}
      <h3 className="text-lg font-semibold text-kumo-default">{title}</h3>
      {description ? <div>{description}</div> : null}
      {action ? <div>{action}</div> : null}
    </div>
  );
}
